import { deleteStockRule } from '../../services/api/stockRule.api';
import { DELETE_STOCK_RULE_REQUEST, DELETE_STOCK_RULE_SUCCESS, DELETE_STOCK_RULE_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[DELETE_STOCK_RULE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[DELETE_STOCK_RULE_SUCCESS](state) {
			state.isLoading = false;
		},
		[DELETE_STOCK_RULE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async removeStockRule({ commit }, id) {
			try {
				commit(DELETE_STOCK_RULE_REQUEST);
				await deleteStockRule(id);
				commit(DELETE_STOCK_RULE_SUCCESS);
			} catch (error) {
				commit(DELETE_STOCK_RULE_FAILURE, error);
			}
		},
	},
};